import { render, staticRenderFns } from "./notifyList.vue?vue&type=template&id=33c952f6&scoped=true&"
import script from "./notifyList.vue?vue&type=script&lang=js&"
export * from "./notifyList.vue?vue&type=script&lang=js&"
import style0 from "./notifyList.vue?vue&type=style&index=0&id=33c952f6&lang=scss&scoped=true&"
import style1 from "./notifyList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c952f6",
  null
  
)

export default component.exports